module.exports = __webpack_public_path__ + "static/img/Eating_500px.72bf6e6.png";